import { Image } from 'antd';
import React from 'react';

 
const Images = () => {



    const images = [
      "https://s3.amazonaws.com/tangledlead.com/images/_storage_.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_0003.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_0005.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_0114.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_0117.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_0902.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1090.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1739.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1842.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1843.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1851.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1855.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1927.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_1930.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20201007_103746_01.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210129_210526.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210322_134728307.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210322_134735230_HDR.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210322_134801031.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210716_143020004.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_20210806_125855290_HDR.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2070.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2249.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2251.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2254.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2593.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2650.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2713.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_2716.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_3348.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_3475.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_4912.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_4913.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_4981.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_4982.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_5055.jpg",
       "https://s3.amazonaws.com/tangledlead.com/images/IMG_5056.jpg",

    ]
    return (
        <div className="flex-row-wrap-space-evenly miw-280">
            {images.map((image, index) => {
                return <div>
                    <Image key={index} src={image} width={360} height={375} className="rem-pad-width p-15 miw-280"/>
                    </div>
            })}
        </div>
    )
}
export default Images